export type NodeType =
  | "start"
  | "minion"
  | "jungle"
  | "recruit"
  | "randomEvent"
  | "boss"
  | "item"
  | "heal"
  | "redBuff"
  | "blueBuff";

export type NodeRewardKind = "levels" | "levelPick" | "recruitEnemy" | "none";

export interface NodeTypeDef {
  type: NodeType;
  displayName: string;
  description: string;
  isCombat: boolean;
  rewardKind: NodeRewardKind;
  fighterLimit: number | null; // null = all roster; determined at runtime for brawl
}

export const NODE_TYPES: Record<NodeType, NodeTypeDef> = {
  start: {
    type: "start",
    displayName: "Start",
    description: "Your journey begins here.",
    isCombat: false,
    rewardKind: "none",
    fighterLimit: null,
  },
  minion: {
    type: "minion",
    displayName: "Minions",
    description: "Gives 1000 XP to one team member.",
    isCombat: true,
    rewardKind: "none",
    fighterLimit: 1,
  },
  jungle: {
    type: "jungle",
    displayName: "Jungle",
    description: "Gives 438 XP to each team member.",
    isCombat: true,
    rewardKind: "none",
    fighterLimit: 1,
  },
  recruit: {
    type: "recruit",
    displayName: "+1 Champion",
    description: "Add 1 of 3 champions to your roster.",
    isCombat: false,
    rewardKind: "none",
    fighterLimit: null,
  },
  randomEvent: {
    type: "randomEvent",
    displayName: "Random Event",
    description: "Anything could happen.",
    isCombat: false,
    rewardKind: "none",
    fighterLimit: null,
  },
  boss: {
    type: "boss",
    displayName: "Boss",
    description: "Beat the strongest champions of this area.",
    isCombat: true,
    rewardKind: "none",
    fighterLimit: null,
  },
  item: {
    type: "item",
    displayName: "Item",
    description: "Pick 1 of 3 items.",
    isCombat: false,
    rewardKind: "none",
    fighterLimit: null,
  },
  heal: {
    type: "heal",
    displayName: "Rest",
    description: "Heals your team to full.",
    isCombat: false,
    rewardKind: "none",
    fighterLimit: null,
  },
  redBuff: {
    type: "redBuff",
    displayName: "Red Buff",
    description: "Gives one team member +50% AD and 15% omnivamp.",
    isCombat: true,
    rewardKind: "none",
    fighterLimit: null,
  },
  blueBuff: {
    type: "blueBuff",
    displayName: "Blue Buff",
    description: "One team member casts every ability twice.",
    isCombat: true,
    rewardKind: "none",
    fighterLimit: null,
  },
};
